import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { View } from 'react-native';
import { BigBodyGroup } from 'fitbeat.gym-core';

import BodyGroupSection from './BodyGroupSection';
import { styles } from './Styles';

class BodyGroups extends Component {
  componentDidUpdate = (prevProps) => {
    if (this.props.disable === true && prevProps.disable === false) {
      this.toggleFullBody();
    }
  }

  toggleUpper = () => {
    this.toggleBodyGroup(BigBodyGroup.Upper);
  }

  toggleLower = () => {
    this.toggleBodyGroup(BigBodyGroup.Lower);
  }

  toggleBackAndArms = () => {
    this.toggleBodyGroup(BigBodyGroup.BackAndArms);
  }

  toggleFullBody = () => {
    this.props.setBodyGroups([BigBodyGroup.BackAndArms, BigBodyGroup.Lower, BigBodyGroup.Upper]);
  }

  toggleBodyGroup = (bodyGroup) => {
    this.props.setBodyGroups([bodyGroup]);
  }

  isBodyGroupSelected = (bodyGroup) => {
    const { workoutSettings: { threeBodyGroups } } = this.props;
    if (threeBodyGroups.length === 0 || threeBodyGroups.length === 3) {
      return bodyGroup === 'FullBody';
    }
    return threeBodyGroups.indexOf(bodyGroup) !== -1;
  };

  render() {
    const { t, workoutSettings, disable } = this.props
    const { cardioOrResistance } = workoutSettings

    return (
      <View style={styles.bodyGroupOptions}>
        <BodyGroupSection
          isActive={this.isBodyGroupSelected(BigBodyGroup.Upper)}
          onPress={this.toggleUpper}
          title={t('bodyGroup', { bodyGroup: BigBodyGroup.Upper })}
          subtitle={t('upperBodyCategories')}
          cardioOrResistance={cardioOrResistance}
          disableCustomize={disable}
        />
        <BodyGroupSection
          isActive={this.isBodyGroupSelected(BigBodyGroup.Lower)}
          onPress={this.toggleLower}
          title={t('bodyGroup', { bodyGroup: BigBodyGroup.Lower })}
          subtitle={t('lowerBodyCategories')}
          cardioOrResistance={cardioOrResistance}
          disableCustomize={disable}
        />
        <BodyGroupSection
          isActive={this.isBodyGroupSelected(BigBodyGroup.BackAndArms)}
          onPress={this.toggleBackAndArms}
          title={BigBodyGroup.BackAndArms}
          subtitle={t('back&ArmsCategories')}
          cardioOrResistance={cardioOrResistance}
          disableCustomize={disable}
        />
        <BodyGroupSection
          isActive={this.isBodyGroupSelected('FullBody')}
          onPress={this.toggleFullBody}
          title={'Full Body'}
          subtitle={'All body groups'}
          cardioOrResistance={cardioOrResistance}
          disableCustomize={disable}
        />
      </View>
    );
  }
}

BodyGroups.propTypes = {
  workoutSettings: PropTypes.object.isRequired,
  setBodyGroups: PropTypes.func.isRequired,
};

export default translate(['bookings'], { wait: true })(BodyGroups);
